import { Content, ContentType } from '@/api/ContentApi';
import { ForeignLanguage, Language } from '@/types/types';

export type AppContent = Record<string, Content>;

export function checkIfExist(
	content: AppContent,
	slug: string,
	language: Language,
	defaultLanguage: Language
): boolean {
	if (!content[slug]) return false;

	const isDefaultLanguage = language === defaultLanguage;

	if (isDefaultLanguage)
		return content[slug].type === ContentType.IMAGE
			? !!content[slug].image
			: !!content[slug].content;

	if (!content[slug].translations || !content[slug].translations[language as ForeignLanguage])
		return false;

	if (content[slug].type === ContentType.IMAGE)
		return !!content[slug].translations[language as ForeignLanguage]?.image;

	return !!content[slug].translations[language as ForeignLanguage]?.content;
}

export function getText(
	content: AppContent,
	slug: string,
	language: Language,
	defaultLanguage: Language,
	vars: Record<string, string | number> = {}
): string {
	const isDefaultLanguage = language === defaultLanguage;
	let text = isDefaultLanguage
		? content[slug]?.content
		: content[slug]?.translations?.[language as ForeignLanguage]?.content;
	text ??= '';

	for (const [variable, value] of Object.entries(vars)) {
		text = text.replaceAll(variable, value.toString());
	}

	return text;
}

export function getEntityText<TObj extends { translations: Record<ForeignLanguage, Partial<Record<keyof TObj, string>>> | null }>(
	obj: TObj,
	key: keyof TObj,
	language: Language,
	defaultLanguage: Language
): string {
	if (language === defaultLanguage) return obj[key] as string;
	const translation = obj.translations?.[language as ForeignLanguage];
	const translatedValue = translation?.[key as keyof Partial<Record<keyof TObj, string>>];
	return (translatedValue as string) ?? (obj[key] as string);
}
